/**
 *  @class
 *  @function GiftingPicker
 */

if (!customElements.get('gifting-picker')) {
  class GiftingPicker extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('#is-gifted');
      this.checkbox.addEventListener('change', this.onToggleGiftPanel.bind(this));

      this.giftingRecipientFields = this.querySelector('.gifting-recipient-fields');
      this.deliverInputs = this.giftingRecipientFields.querySelectorAll('input')

      this.giftingDateFields = this.querySelector('.gifting-date-fields');
      
      for (let elem of this.querySelectorAll('input[type="radio"][name="_deliver_to"]')) {
        elem.addEventListener('change', this.onToggleDeliverToPanel.bind(this));
      };

      for (let elem of this.querySelectorAll('input[type="radio"][name="_deliver_date"]')) {
        elem.addEventListener('change', this.onToggleDeliveryDatePanel.bind(this));
      };

      this.deliverOn = this.querySelector('#_deliver_on')
      this.deliveryDate = this.querySelector('#gifting-delivery-date');
    }

    connectedCallback() {
      this.datePicker = new easepick.create({
        element: this.deliveryDate,
        css: [
          'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
        ],
        zIndex: 50,
        header: "When would you like to deliver the gift?",
        LockPlugin: {
          minDate: new Date()
        },
        format: "YYYY-MM-DD",
        date: this.deliveryDate.value,
        plugins: [
          "LockPlugin"
        ]
      });

      this.datePicker.on('select', this.onDateSelect.bind(this));
    }

    onDateSelect() {
      this.deliverOn.value = this.datePicker.getDate().format('DD-MM-YYYY')
    }

    onToggleGiftPanel() {
      this.classList.toggle('active');

      if (this.checkbox.checked) {
        this.setRequired('#gifting-your-name');
      } else {
        this.removeRequired('#gifting-your-name');
        this.clearFields();
      }
    }

    onToggleDeliverToPanel(event) {
      this.giftingRecipientFields.classList.toggle('active');

      if (event.target.value === 'recipient') {
        this.setRequired('#gifting-your-email');
        this.querySelector('#_deliver_now').checked = true;
        this.enableDeliverInputs();
        this.datePicker.clear(); // Reset the date picker, as the default is to deliver immediately
      } else {
        this.giftingDateFields.classList.toggle('active', false);
        this.removeRequired('#gifting-your-email');
        this.deliverOn.value = '';
        this.disableDeliverInputs();
      }
    }

    onToggleDeliveryDatePanel(event) {
      this.giftingDateFields.classList.toggle('active');
      var now = new Date();
      var dateFormatter = new Intl.DateTimeFormat('en-GB', { year: 'numeric', month: '2-digit', day: '2-digit' });

      if (event.target.value === 'date') {
        this.datePicker.setDate(dateFormatter.format(now));
        this.onDateSelect();
      } else {
        this.datePicker.clear();
        this.deliverOn.value = '';
      }
    }

    setRequired(selector) {
      this.querySelector(selector).setAttribute('required', '');
    }

    removeRequired(selector) {
      this.querySelector(selector).removeAttribute('required');
    }

    clearFields() {
      for (let elem of this.querySelectorAll('input[type="text"], input[type="email"],textarea')) {
        elem.value = '';
      }
    }

    enableDeliverInputs() {
      for (let elem of this.deliverInputs) {
        elem.removeAttribute('disabled');
      }
    }

    disableDeliverInputs() {
      for (let elem of this.deliverInputs) {
        elem.setAttribute('disabled', '');
      }
    }
  }

  customElements.define('gifting-picker', GiftingPicker);
}